export const STORAGE_KEYS = Object.freeze({
  transferToken: 'transfer_token',
  authCode: 'code',
  email: 'email',
});
